var getDevice = (function () {
  var ua = navigator.userAgent;
  if (
    ua.indexOf("iPhone") > 0 ||
    ua.indexOf("iPod") > 0 ||
    (ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0)
  ) {
    return "sp";
  }
  return "other";
})();

var tag = document.createElement("script");
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName("script")[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var player;
var width = window.innerWidth;
var breakpoint = 850;

function playingVideoInfo(pageTag) {
  if (getDevice == "sp" || width < breakpoint) {
    height = width * 1.7777;
    if (pageTag == "landing") {
      videoId = "C3tq8oCS0Do";
    }
    if (pageTag == "thanks") {
      videoId = "KG-jZoa9b98";
    }
  } else {
    height = width * 0.5625;
    if (pageTag == "landing") {
      videoId = "YR31jv-AtMg";
    }
    if (pageTag == "thanks") {
      var videoId = "Z3eVwiJVn6g";
    }
  }
  return [videoId, height];
}

window.onYouTubeIframeAPIReady = function () {
  pageTag = (function () {
    if ($(".landing-index").length > 0) {
      return "landing";
    } else if ($(".thanks").length > 0) {
      return "thanks";
    } else {
      return "";
    }
  })();
  vidoeInfo = playingVideoInfo(pageTag);
  videoId = vidoeInfo[0];
  height = vidoeInfo[1];

  player = new YT.Player("player", {
    height: height,
    width: width,
    videoId: videoId,
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerStateChange,
    },
    playerVars: {
      controls: 0,
      showinfo: 0,
      rel: 0,
      enablejsapi: 1,
      autoplay: 1,
      playsinline: 1,
      vq: "hd1080",
      widgetid: 1,
      mute: 1,
      origin: "https://geek-salon.com/",
    },
  });
};

function onPlayerReady(event) {
  player = event.target;
  player.mute();
  player.playVideo();
  setTimeout(movieStart, 1000); //ローディングを1秒待つ
}

function onPlayerStateChange(event) {
  if (event.data == YT.PlayerState.ENDED) {
    player = event.target;
    player.seekTo(0);
  }
}

function movieStart() {
  player.seekTo(0);
  $("#player").css("z-index", "1");
}
